

var ORDERINGS = {
  ascending: "ASC",
  descending: "DESC"
};


export default function parseSort(sql, transform) {
  transform.field.forEach(function (field, index) {
    sql.orderby.push(field + (Array.isArray(transform.order) ? " " + ORDERINGS[transform.order[index]] : ""));
  });
  return sql;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mapd-data-layer-2/es/parser/parse-sort.js
// module id = 126
// module chunks = 0 1